import {InputTextV2} from '@prtimes-basis/input';
import {useController} from 'react-hook-form';
import {type ChangeEvent} from 'react';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';
import {
  ipoKbnListWithoutCode,
  useCompanyRegistrationFormContext,
} from '@/features/company-registration/form';

export function SecurityCodeField() {
  return (
    <FormField.Root name='companyInfo.securityCode'>
      <Body />

      <FormField.Error />
    </FormField.Root>
  );
}

function Body() {
  const {control, isError} = useFormField();
  const {field} = useController({control, name: 'companyInfo.securityCode'});
  const {
    trigger,
    watch,
    formState: {isSubmitted},
  } = useCompanyRegistrationFormContext();
  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    field.onChange(event.target.value);
    if (isSubmitted) void trigger('companyInfo.securityCode');
  };

  const isRequired = !ipoKbnListWithoutCode.has(
    watch('companyInfo.securityCode'),
  );

  return (
    <InputTextV2
      ref={field.ref}
      wrapperClassName={companyRegistrationPageStyles.sizedInput}
      required={isRequired}
      value={field.value}
      error={isError}
      aria-label='証券コード'
      aria-invalid={isError}
      aria-describedby={`${field.name}-error`}
      onChange={onChange}
    />
  );
}
